export default __webpack_public_path__ + "static/media/export.1665bb6f.svg";